import { Component, OnInit } from '@angular/core';
import {
  CollectionScreenStore,
  OutfitReference,
  OutfitReferenceJson,
} from '../../collection-screen.state';
import { CommonModule } from '@angular/common';
import { BaseListRowComponent } from '../base-list-row/base-list-row.component';
import { RowButtonsComponent } from '../row-buttons/row-buttons.component';
import { SimpleFileService } from '../../services/file.service';
import { RRCopyToClipboardModule } from 'projects/web-ui-component-library/src';
import { CopyToClipboardComponent } from '../copy-to-clipboard/copy-to-clipboard.component';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { CollectionBaseReference } from '../../../collection-overview/collection.interface';
import { CentralAssetPlatformService } from '../../../data/services/central-asset-platform.service';

@Component({
  selector: 'app-outfit-list-row',
  standalone: true,
  imports: [
    CommonModule,
    RowButtonsComponent,
    RRCopyToClipboardModule,
    CopyToClipboardComponent,
    CdkDragHandle,
  ],
  templateUrl: './outfit-list-row.component.html',
  styleUrls: ['../base-list-row/base-list-row.scss'],
})
export class OutfitListRowComponent
  extends BaseListRowComponent<OutfitReferenceJson>
  implements OnInit
{
  public fileContent: string;
  public missingGarments: CollectionBaseReference[] = [];

  constructor(
    private _simpleFileService: SimpleFileService,
    private _createCollectionStore: CollectionScreenStore,
    private _capService: CentralAssetPlatformService,
  ) {
    super();
  }
  ngOnInit(): void {
    if (this.reference?.resultUrl) {
      this._simpleFileService
        .readJsonFile(this.reference.resultUrl)
        .subscribe((res) => {
          this.calculateMissingGarments(res);
          this.fileContent = btoa(
            JSON.stringify({
              type: 'pictofit::virtualstyling::style',
              collection: res,
            }),
          );
        });
    }
  }

  calculateMissingGarments(res: OutfitReference) {
    const garments = [...res.garments, ...(res.accessories ?? [])];

    let existingGarments: string[] = [];
    this._createCollectionStore.garments$.subscribe((gs) => {
      existingGarments = gs.map((g) => g.reference);
      this.missingGarments = garments.filter(
        (g) => !existingGarments.includes(g.reference),
      );
    });
  }

  async addMissingGarments() {
    const abortController = new AbortController();
    for (const mg of this.missingGarments) {
      const data = await this._capService.getAdditionalData(
        mg.organizationId,
        [mg.reference],
        abortController.signal,
      );
      console.warn(data);
      if (data.length === 0) {
        console.warn(
          `Could not find garment with reference ${mg.reference} in org ${mg.organizationId}`,
        );
        continue;
      }
      this._createCollectionStore.addOrUpdateGarment({
        id: data[0]?.id ?? '',
        thumbnail: data[0]?.thumbnail ?? '',
        name: data[0]?.name ?? '',
        reference: mg.reference,
        organizationId: mg.organizationId,
      });
    }
  }

  get missingGarmentsNames(): string {
    return this.missingGarments?.map((g) => g.reference).join(', ') || '';
  }
}
